import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '使用指南', path: '/category/guide' },
      { label: '功能介绍', path: '/category/features' },
      { label: '常见问题', path: '/category/faq-articles' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户评价', path: '/about#reviews' },
      { label: '联系方式', path: '/about#contact' },
      { label: '安全与隐私', path: '/category/security' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '新手指南', path: '/article/registration-login-tutorial' },
      { label: '会员权益', path: '/article/membership-benefits-pricing' },
      { label: '社区规范', path: '/article/community-guidelines' },
      { label: '更新日志', path: '/category/changelog' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/70">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-lg">17</span>
              </div>
              <span className="font-heading font-semibold text-foreground-900 text-lg">17c.com</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              您值得信赖的在线平台，提供丰富的内容与服务资源。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-foreground-900 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 17c.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="/category/security" className="hover:text-primary-600 transition-colors">隐私政策</a>
            <a href="/category/security" className="hover:text-primary-600 transition-colors">服务条款</a>
            <a href="/about#contact" className="hover:text-primary-600 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}